import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const questions = new RepositoryFactory('question');

export default {
  namespaced: true,
  state: {
    // Single class
    question: {},
    questions: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    getProfileQuestions(state) {
      if (state.questions.length > 0) {
        return state.questions.filter((s) => s.type === 'profile');
      } else {
        return [];
      }
    },
    currentPage(state) {
      return state.currentPage;
    },
    getQuestion(state) {
      return state.question;
    },
    getQuestions(state) {
      for (const iterator of state.questions) {
        if (iterator.type === 'brand') {
          iterator.typeResponse = iterator.brands.name;
        }
        if (iterator.profile) {
          iterator.typeResponse = iterator.profile.slug;
        }
      }
      return state.questions.map((s) => ({
        id: s.id,
        type: s.type,
        content: s.typeResponse,
      }));
    },
    getAllQuestions(state) {
      return state.questions;
    },
    getQuestionsTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_QUESTION(state, data) {
      state.question = data;
    },
    SET_QUESTIONS(state, data) {
      state.questions = data.items;
      state.total = data.totalOfItems;
      state.totalPages = data.pageCount || 0;
    },
    SET_ALL_QUESTIONS(state, data) {
      state.questions = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getQuestions');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getQuestions');
    },
    searchQuestion: async ({ commit }, payload) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await questions.getWithSearch(payload.search, payload.extraParams, payload.page, payload.limit);
        commit('SET_PAGE', payload.page);
        commit('SET_QUESTIONS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        const res = await questions.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Questão criada com sucesso!',
        });
        dispatch('getQuestions');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: 'Erro: essa questão já existe',
        });
      }
    },
    getQuestionById: async ({ commit }, id) => {
      try {
        const { data } = await questions.getById(id);
        commit('SET_QUESTION', data);
      } catch (error) {}
    },
    getQuestions: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await questions.get(state.currentPage);
        commit('SET_QUESTIONS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getQuestionsNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await questions.get();
        commit('SET_ALL_QUESTIONS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
